import React, { FC, ChangeEvent, FocusEvent } from 'react'
import classnames from 'classnames'
import style from './Input.module.css'

type InputProps = {
  className?: string
  type?: string
  name?: string
  value?: string
  placeholder?: string
  disabled: boolean
  isError?: boolean
  onChange?(e: ChangeEvent<HTMLInputElement>): void
  onFocus?(data: FocusEvent<HTMLInputElement, Element>): void
  onBlur?(e: FocusEvent<HTMLInputElement, Element>): void
}

export const Input: FC<InputProps> = ({
  className,
  type,
  name,
  value,
  disabled,
  placeholder,
  isError,
  onChange,
  onFocus,
  onBlur,
}) => {
  const classNames = classnames(style.input, className, {
    [style.errorField]: isError,
  })

  return (
    <input
      className={classNames}
      type={type}
      name={name}
      value={value}
      placeholder={placeholder}
      disabled={disabled}
      onChange={onChange}
      onFocus={onFocus}
      onBlur={onBlur}
    />
  )
}

Input.displayName = 'Input'
